import React from 'react';

import { ClinicalAllergy } from '../types';
import { formatAllergyName, formatDate, formatEnumLabel } from '../utils/formatters';
import * as Style from '../style.module.scss';
import EhrCard from './EhrCard';
import StatusPill from './StatusPill';
import { allergyStatusTone } from './StatusPill/tones';

type Props = {
    allergies: ClinicalAllergy[];
    lastSynced?: string;
};

const Allergies: React.FC<Props> = ({ allergies, lastSynced }) => (
    <EhrCard
        title="Allergies"
        meta={lastSynced}
        isEmpty={!allergies.length}
        emptyMessage="No known allergies recorded."
    >
        <div className={Style.list}>
            {allergies.map((allergy) => (
                <div key={allergy.id} className={Style.listRow}>
                    <div>
                        <span className={Style.primary}>{formatAllergyName(allergy)}</span>
                        {allergy.reaction ? (
                            <span className={Style.muted}>{` ${allergy.reaction}`}</span>
                        ) : null}
                        {allergy.removed_at ? (
                            <span className={Style.removed}>
                                {`Removed ${formatDate(allergy.removed_at)}`}
                            </span>
                        ) : null}
                        {allergy.notes ? (
                            <span className={Style.subText}>{allergy.notes}</span>
                        ) : null}
                    </div>
                    <StatusPill
                        label={formatEnumLabel(allergy.status)}
                        tone={allergyStatusTone(allergy.status)}
                    />
                </div>
            ))}
        </div>
    </EhrCard>
);

export default Allergies;
